export default class Clients {
    constructor() {
        this.clients = document.querySelectorAll('.fd-block-clients');
        this.init();
    }

    init() {
        console.log('clients.init');
        if(this.clients.length) {
            this.clients.forEach((elt, index) => {
                const swiperElement = elt.querySelector('.swiper-clients');

                if(swiperElement) {
                    const pagination = elt.querySelector('.swiper-pagination');
                    pagination.id = `swiper-pagination-${index}`;

                    const swiper = new Swiper(swiperElement, {
                        slidesPerView: 1.01,
                        centeredSlides: false,
                        spaceBetween: 5,
                        grabCursor: true,
                        pagination: {
                            el: `#swiper-pagination-${index}`,
                            type: 'bullets',
                            clickable: true
                        },
                        navigation: {
                            nextEl: elt.querySelector('.swiper-next'),
                            prevEl: elt.querySelector('.swiper-prev'),
                        },

                        breakpoints: {
                            768: {
                                slidesPerView: 2.01,
                            },
                            1024: {
                                slidesPerView: 3.01,
                                spaceBetween: 30,
                            }
                        }
                    });

                    swiper.on('slideChange', function () {
                        const activeIndex = swiper.realIndex;
                        const bullets = pagination.querySelectorAll('.swiper-pagination-bullet');

                        bullets.forEach((bullet) => bullet.classList.remove('swiper-pagination-bullet-active'));

                        if (bullets[activeIndex]) {
                            bullets[activeIndex].classList.add('swiper-pagination-bullet-active');
                        }
                    });
                }
            })
        }
    }
}
